module.exports = __webpack_public_path__ + "static/media/about_us.31fff2fd.png";